import { render, staticRenderFns } from "./CommunicationTab.vue?vue&type=template&id=035adc75&scoped=true"
import script from "./CommunicationTab.vue?vue&type=script&lang=js"
export * from "./CommunicationTab.vue?vue&type=script&lang=js"
import style0 from "./CommunicationTab.vue?vue&type=style&index=0&id=035adc75&prod&lang=scss"
import style1 from "./CommunicationTab.vue?vue&type=style&index=1&id=035adc75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035adc75",
  null
  
)

export default component.exports